
































import { defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import BaseAvatar from "@/components/BaseAvatar";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import BaseSpinner from "@/components/BaseSpinner";
import EmptyContent from "@/components/EmptyContent";
import ListItem from "@/components/ListItem";

export default defineComponent({
  name: "ModalSwitchAccount",
  components: { ListItem, BaseAvatar, BaseIcon, BaseSpinner, EmptyContent, BaseConfirm },
  props: {
    show: { type: Boolean, default: false },
    users: { type: Array as () => UserPublicData[], required: true },
    loadingUserId: { type: String, required: true },
  },
  setup(_, { emit }) {
    const { authUserStrict } = useAuthUser();
    const closeModal = () => emit("close");
    const handleClick = (user: UserPublicData) => emit("accountClick", user);
    const checkCurrentUser = (userId: string) => userId === authUserStrict.value.id;

    return {
      closeModal,
      handleClick,
      checkCurrentUser,
    };
  },
});
